var React = require('react');

function Bandcamp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm48.2 326.1h-181L199.9 178h181l-84.7 156.1z"}));
}

Bandcamp.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Bandcamp;

Bandcamp.default = Bandcamp;
